import { FC } from 'react';

//styles
// import Image from 'next/image';
import styles from './footer-service.module.scss';
import { ServiceData } from '@/data/footer-assets';
import { useIntl } from 'react-intl';

export interface IFooterServiceProps {
  service: ServiceData;
}

const FooterService: FC<IFooterServiceProps> = ({ service: { title, description, image, altText, width, height } }) => {
  const { formatMessage } = useIntl();
  //language conversions
  const serviceTitle = formatMessage({ id: title }).toUpperCase();
  const serviceDescription = formatMessage({ id: description ?? `${title}Description` });
  // Match PC Optimum
  const pcOptimumMatch = serviceDescription.match(/([\w\s]*)(PC Optimum)([\w\s]*)/);

  return (
    <div className={styles.footerServiceContainer}>
      <div className={styles.imageContainer}>
        <img
          className={styles.serviceImage}
          src={image}
          alt={formatMessage({ id: altText ?? `${title}Alt` })}
          width={width}
          height={height}
        />
      </div>
      <div className={styles.serviceInfo}>
        <p className={styles.serviceTitle}>{serviceTitle}</p>
        <p className={styles.serviceDescription}>
          {/* If "PC Optimum" make it italic */}
          {pcOptimumMatch
            ? pcOptimumMatch.slice(1).map((text) => (text == 'PC Optimum' ? <i key={text}>PC Optimum</i> : text))
            : serviceDescription}
        </p>
      </div>
    </div>
  );
};

export default FooterService;
